<template>
    <SidebarChild :selected-item="value" :items="getMenuItems()" :focusActive="true" @selected="selectedItem" />
</template>
<script>
import SidebarChild from "../../../../components/Sidebar/SidebarChild.vue";
import MenuItems from "./MenuItems";
import { mapGetters, mapState, mapActions } from "vuex";
import SYSTEM_PUBSUB from "../../../../utils/systemPubSub";
import { deleteFilter } from "../../../../api/favFilters";

export default {
    name: "ChatSidebar",
    components: {
        SidebarChild,
    },
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
    },
    computed: {
        ...mapState({
            liveVisitorCount: (state) => state.visitor.liveVisitorCount,
            chatTotal: (state) => state.chat.stats.total,
            unreadMessages: (state) => state.team.unreadMessages.filter((chat) => chat.unreadCount > 0).length,
            chatbotLive: (state) => state.chat.stats.chatbot,
            websiteTrackingUrl: (state) => state.setting.settings?.websiteTrackingUrl,
            whatsappChannelExists: (state) =>
                state.channel.channels.find((channel) => channel.type.includes("whatsapp")),
            messengerChannelExists: (state) =>
                state.channel.channels.find((channel) => channel.type.includes("messenger")),
            instagramChannelExists: (state) =>
                state.channel.channels.find((channel) => channel.type.includes("instagram")),
            linkedinChannelExists: (state) =>
                state.channel.channels.find((channel) => channel.type.includes("linkedin-unipile")),
            telegramChannelExists: (state) =>
                state.channel.channels.find((channel) => channel.type.includes("telegram-unipile")),
            metaLeadsChannelExists: (state) =>
                state.channel.channels.find((channel) => channel.type.includes("meta-lead")),
            channels: (state) => state.channel.channels,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
            customChatFilters: "favFilters/customChatFilters",
        }),
    },
    data: () => ({
        MenuItems: [],
    }),
    mounted() {
        this.MenuItems = this.getMenuItems();
    },
    created() {
        this.MenuItems = this.getMenuItems();
    },
    methods: {
        ...mapActions({
            syncFilters: "favFilters/syncFilters",
        }),
        selectedItem({ key }) {
            this.$emit("input", key);
        },
        getMenuItems() {
            console.log("getMenuItems...");
            return [
                {
                    enabled: true,
                    key: "liveSupport",
                    label: this.$t("message.liveSupport"),
                    icon: {
                        type: "material-icons",
                        name: "support_agent",
                    },
                    dataKey: "liveSupport",
                    clickCallback: () => {
                        const previousSelectedCustomFilterTemplate =
                            this.$store.state.chat.previousSelectedCustomFilterTemplate;
                        console.log("clickCallback liveSupport...", previousSelectedCustomFilterTemplate);
                        setTimeout(() => {
                            SYSTEM_PUBSUB.publish(
                                SYSTEM_PUBSUB.MESSAGE_TYPES.APPLY_FILTER_TEMPLATE,
                                previousSelectedCustomFilterTemplate !== "custom"
                                    ? previousSelectedCustomFilterTemplate
                                    : "all-agent-inbox"
                            );
                        }, 100);
                    },
                },
                ...this.customChatFilters.map((filter) => ({
                    enabled: true,
                    key: `fav_filter-${filter._id}`,
                    label: filter.name,
                    icon: {
                        type: "material-icons",
                        name: filter.icon || "filter_list",
                    },
                    dataKey: filter._id,
                    showDeleteButton: true,
                    clickCallback: () => {
                        console.log("clickCallback favFilter...", filter);
                        setTimeout(() => {}, 300);
                    },
                    onDelete: () => {
                        this.$confirm({
                            title: this.$t("message.deleteOperation"),
                            content: this.$t("message.deleteConfirmationMessage"),
                            onOk: () => {
                                console.log("onDelete favFilter...", filter);
                                deleteFilter(filter._id)
                                    .then(() => {
                                        console.log("Filtre başarıyla silindi");
                                        // Gerekirse burada ek işlemler yapabilirsiniz
                                        this.$message.success(this.$t("message.deleteSuccess"));
                                        this.syncFilters("page.chat-list");
                                        const isCurrentSelected =
                                            this.$store.state.chat.selectedFavoriteFilter?._id === filter._id;
                                        if (isCurrentSelected) {
                                            SYSTEM_PUBSUB.publish(
                                                SYSTEM_PUBSUB.MESSAGE_TYPES.APPLY_FILTER_TEMPLATE,
                                                "all-agent-inbox"
                                            );
                                        }
                                    })
                                    .catch((error) => {
                                        console.error("Filtre silinirken hata oluştu:", error);
                                        this.$message.error("Filtre silinirken hata oluştu");
                                    });
                            },
                            onCancel: () => {
                                console.log("Silme işlemi iptal edildi");
                            },
                        });
                    },
                    // clickEvent: () => {
                    //     console.log("clickEvent favFilter...");
                    //     this.$router.push({ query: { favFilter: filter._id } });
                    // },
                })),
                {
                    enabled: true,
                    key: "teamChat",
                    label: this.$t("message.teamChat"),
                    counter: this?.unreadMessages,
                    icon: {
                        type: "material-icons",
                        name: "group",
                    },
                    dataKey: "teamChat",
                },
                {
                    enabled: true,
                    key: "siteVisitors",
                    label: this.$t("message.siteVisitors"),
                    counter: this?.liveVisitorCount,
                    icon: {
                        type: "material-icons",
                        name: "public",
                    },
                    dataKey: "siteVisitors",
                },
                {
                    enabled: true,
                    key: "conversationHistory",
                    label: this.$t("message.conversationHistory"),
                    icon: {
                        type: "material-icons",
                        name: "history",
                    },
                    dataKey: "conversationHistory",
                },
                {
                    enabled: true,
                    key: "representative",
                    label: this.$t("message.representative"),
                    icon: {
                        type: "material-icons",
                        name: "engineering",
                    },
                    dataKey: "representative",
                },
                {
                    enabled: this?.whatsappChannelExists,
                    key: "whatsappContacts",
                    label: this.$t("WhatsappContacts"),
                    icon: {
                        type: "component",
                        name: "WhatsappIcon",
                    },
                    dataKey: "whatsappContacts",
                },
                {
                    enabled: this?.instagramChannelExists,
                    key: "instagramContacts",
                    label: this.$t("InstagramContacts"),
                    icon: {
                        type: "component",
                        name: "InstagramIcon",
                    },
                    dataKey: "instagramContacts",
                },
                {
                    enabled: this?.messengerChannelExists,
                    key: "messengerContacts",
                    label: this.$t("MessengerContacts"),
                    icon: {
                        type: "component",
                        name: "MessengerIcon",
                    },
                    dataKey: "messengerContacts",
                },
                {
                    enabled: this?.linkedinChannelExists,
                    key: "linkedinContacts",
                    label: this.$t("LinkedinContacts"),
                    icon: {
                        type: "component",
                        name: "LinkedinIcon",
                    },
                    dataKey: "linkedinContacts",
                },
                {
                    enabled: this?.telegramChannelExists,
                    key: "telegramContacts",
                    label: this.$t("TelegramContacts"),
                    icon: {
                        type: "component",
                        name: "TelegramIcon",
                    },
                    dataKey: "telegramContacts",
                },
                {
                    enabled: this?.metaLeadsChannelExists,
                    key: "metaLeads",
                    label: "Meta Leads",
                    icon: {
                        type: "component",
                        name: "MetaIcon",
                    },
                    dataKey: "metaLeads",
                },
                {
                    enabled: true,
                    key: "activities",
                    label: this.$t("notification.activities"),
                    icon: {
                        type: "material-icons",
                        name: "rss_feed",
                    },
                    dataKey: "activities",
                },
                {
                    enabled: !!this?.websiteTrackingUrl,
                    key: "websiteAnalytics",
                    label: "Website Analytics",
                    icon: {
                        type: "material-icons",
                        name: "analytics",
                    },
                    dataKey: "websiteAnalytics",
                },
                {
                    enabled: true,
                    key: "automations",
                    label: this.$t("automation.automations"),
                    icon: {
                        type: "component",
                        name: "atomic-power",
                        class: "myIcon",
                        style: { fill: "var(--color-icon-primary-default)" },
                    },
                    dataKey: "automations",
                },
            ];
        },
    },
    watch: {
        liveVisitorCount() {
            this.MenuItems = this.getMenuItems();
        },
        chatTotal() {
            this.MenuItems = this.getMenuItems();
        },
        unreadMessages() {
            this.MenuItems = this.getMenuItems();
        },
        chatbotLive() {
            this.MenuItems = this.getMenuItems();
        },
        channels: {
            deep: true,
            handler() {
                this.MenuItems = this.getMenuItems();
            },
        },
    },
};
</script>
